import React from "react";

import st from "lib/utils/index";
import * as FormControl from "lib/components/FormControl";
import { ProductLocationDecorator } from "lib/decorators/index";

export default class ProductLocationFormSection extends React.PureComponent {
  handleLocationChange({ name, lat, lng }) {
    const { product_location, editedLocale, onChange } = this.props;
    const nextProductLocation = new ProductLocationDecorator({
      ...product_location,
      location_lat: lat,
      location_lng: lng,
      translations: product_location.translations
        .filter((t) => t.locale !== editedLocale)
        .concat([{ ...product_location.getTranslation(editedLocale), location_name: name }]),
    });
    onChange(nextProductLocation);
  }

  render() {
    const { readOnlyAccess, product_location, editedLocale, errors, name, index } = this.props;

    return (
      <div className="field">
        {index === 0 && <label>{I18n.t("papp.products.EditProductView.StepLocation.main_location_label")}</label>}
        {index === 1 && <label>{I18n.t("papp.products.EditProductView.StepLocation.other_locations_label")}</label>}

        <FormControl.LocationFormGroup
          {...FormControl.addProps(`${name}.location`, { errors })}
          value={{
            name: product_location.getTranslation(editedLocale).location_name,
            lat: product_location.location_lat,
            lng: product_location.location_lng,
          }}
          onChange={this.handleLocationChange.bind(this)}
          readOnly={readOnlyAccess}
          editedLocale={editedLocale}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/products/EditProductView/StepLocation/ProductLocationFormSection.jsx